module.exports = __webpack_public_path__ + "static/img/koentjoro.3925da5.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/testimonial/koentjoro.jpeg
// module id = yQWD
// module chunks = 1